export const TimelineScrollHandler = () => {
    const timeLine =  document.getElementsByClassName('.time-line');

    if (typeof(timeLine) != 'undefined' && timeLine != null) {
        const allSections = document.querySelectorAll(".time-line__item-wrapper");

        const revealSection = function (entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) { 
                    entry.target.classList.add("time-line__item-wrapper--active");
                }
            });
        };

        const sectionObserver = new IntersectionObserver(revealSection, {
            root: null,
            threshold: 0.2,
        });

        allSections.forEach((section) => {
            sectionObserver.observe(section);
        });
    }
};
